import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Paper, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import axios from '../../utils/axios';

const AuthDebug = () => {
  const { user, token, isAuthenticated } = useAuth();
  const [debugInfo, setDebugInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDebugInfo = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get('/api/v1/auth/debug');
      setDebugInfo(response.data);
    } catch (err) {
      setError(err.message || 'Failed to fetch debug info');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Initial fetch when component mounts
    fetchDebugInfo();
  }, []);

  return (
    <Paper 
      elevation={3} 
      sx={{ 
        p: 3, 
        maxWidth: 600, 
        mx: 'auto', 
        my: 4,
        overflow: 'auto'
      }}
    >
      <Typography variant="h5" gutterBottom>Auth Debug Information</Typography>
      
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">Authentication Status</Typography>
        <Typography>Is Authenticated: {isAuthenticated ? 'Yes' : 'No'}</Typography>
        <Typography>User: {user ? JSON.stringify(user) : 'Not logged in'}</Typography>
        <Typography>Token: {token ? `${token.substring(0, 15)}...` : 'None'}</Typography>
      </Box>
      
      <Button 
        variant="contained" 
        onClick={fetchDebugInfo} 
        disabled={loading}
        sx={{ mb: 2 }}
      >
        {loading ? <CircularProgress size={24} /> : 'Refresh Debug Info'}
      </Button>
      
      {error && (
        <Typography color="error" sx={{ my: 2 }}>
          Error: {error}
        </Typography>
      )}
      
      {debugInfo && (
        <Box component="pre" sx={{ mt: 2, backgroundColor: '#f5f5f5', p: 2, borderRadius: 1, overflow: 'auto' }}>
          {JSON.stringify(debugInfo, null, 2)}
        </Box>
      )}
    </Paper>
  );
};

export default AuthDebug;